import { NextSeo } from 'next-seo'
import Link from 'next/link'
import { MainLayout } from '@/components/layout/MainLayout'
import { useContent } from '../../hooks/useContent';
import InsightsHero from '@/components/sections/InsightsHero';
import FDIOutlook from '@/components/sections/FDIOutlook';
import FDIPerformance from '@/components/sections/FDIPerformance';
import KeyFindingsSection from '@/components/sections/KeyFindingsSection';
import QualityFdiSlider from '@/components/sliders/QualityFdiSlider';
import HeroSection from '@/components/sections/HeroSection';
import PolicyAreasSection from '@/components/sections/PolicyAreasSection';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

const SubMenu: React.FC = () => {
  const [progressWidth, setProgressWidth] = useState(0);
  const { locale } = useRouter();  

  const handleScroll = () => {
    const scrollTop = window.scrollY; // Şu anda scroll yapılan mesafe
    const windowHeight = window.innerHeight; // Görünen pencere yüksekliği
    const docHeight = document.documentElement.scrollHeight - windowHeight; // Sayfanın toplam uzunluğu - pencere yüksekliği
    const scrollPercentage = (scrollTop / docHeight) * 100; // Sayfanın neresinde olduğumuzu yüzdelik hesapla
    setProgressWidth(scrollPercentage);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Component unmount olduğunda event listener'ı kaldır
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div className="index-wrapper">
        <div className="index-item-wrapper">
          <div className="index-chapter">
            <Link href="#fdi-outlook" className="index-item">
            {locale === 'tr' ? 'UDY Görünümü ve Temel Eğilimler' : 'FDI OUTLOOK & Key TRENDS'}
            </Link>
            <div className="item-line"></div>
            <div className="item-line is-start"></div>
          </div>
          <div className="index-chapter">
            <div className="item-line"></div>
            <Link href="#fdi-performance" className="index-item">
            {locale === 'tr' ? 'Performans ve Ekosistem' : 'PERFORMANCE & ECOSYSTEM'}
            </Link>
          </div>
          <div className="index-chapter">
            <Link href="#key-findings" className="index-item">
            {locale === 'tr' ? 'Temel Bulgular' : 'KEY FINDINGS'}
            </Link>
            <div className="item-line"></div>
          </div>
          <div className="index-chapter">
            <Link href="#quality-fdi" className="index-item">
            {locale === 'tr' ? 'Nitelikli UDY' : 'QUALITY FDI'}
            </Link>
            <div className="item-line"></div>
          </div>
        </div>
        <div className="index-progress">
          <div className="index-progress-bar" style={{ width: `${progressWidth}%`, transition: 'width 0.2s ease', willChange: 'width, height' }}>
            <div className="point"></div>
          </div>
        </div>
      </div>
      <div className="index-trigger-wrapper">
        <div className="index-trigger">
          <Link href="#" className="hamburger-wrapper">
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default SubMenu;


export const InsightsPage: React.FC = () => {
  const { content } = useContent();
  const { locale } = useRouter();

  return (
    <>
      <NextSeo
        title={'Türkiye’s FDI Strategy | Investment Office Türkiye'}
        description={
          'Discover Türkiye’s FDI Strategy with the Investment Office of Türkiye. Explore key investment opportunities, strategic insights, and the latest updates to support your business growth in Türkiye.'
        }
        twitter={{
          cardType: 'summary_large_image',
        }}
        openGraph={{
          title: 'Türkiye’s FDI Strategy | Investment Office Türkiye',
          description:
            'Discover Türkiye’s FDI Strategy with the Investment Office of Türkiye. Explore key investment opportunities, strategic insights, and the latest updates to support your business growth in Türkiye.',
          images: [
            {
              url: `https://uploads-ssl.webflow.com/666f68e852029a839d204e3c/66c1a963eeae257ddfa3fb86_FDI%20Strategy%20Design%20Guideline%20Visualized%20EN%20Reduced.avif`,
              width: 1024,
              height: 1024,
              type: 'image/jpeg',
            },
          ],
        }}
        noindex={locale === 'tr'}
        nofollow={locale === 'tr'}
      />
      <MainLayout optionalSubMenu={<SubMenu />} isAnimateMenu={true}>
        <>
          <InsightsHero
            data={content.insightsHero}
          />
          <FDIOutlook />
          <FDIPerformance data={content.fdiPerformance} />
          <KeyFindingsSection data={content.keyFindingsSection} />
          <QualityFdiSlider
            slides={content.qualityFdiSlider.slides}
            tagline={content.qualityFdiSlider.tagline}
            heading={content.qualityFdiSlider.heading}
          />
          <HeroSection
            heroData={content.insightHeroSection}
            stickySections={content.goals}
          />
          <PolicyAreasSection
            cards={content.policyAreasSection.cards}
            tagline={content.policyAreasSection.tagline}
            heading={content.policyAreasSection.heading}
          />
        </>
      </MainLayout>
    </>
  )
}
